import Styles from './styles.module.css';
import SectionTitle from '../../home/_ui/sectionTitle';
import { IoCheckmarkCircle } from 'react-icons/io5';

const ITEMS = [
  '紙の求人票をスキャンする',
  'PDF のファイル名を付け直す',
  'Google Drive・共有フォルダへ手動で保存する',
  '年度・企業ごとにフォルダを分けて整理する',
  '紙の求人票をファイルに綴じて保管する',
  '学生向けの案内に求人情報を書き写す',
  '「あの求人票どこだっけ」と探す',
];

const Reduce = () => {
  return (
    <section className={Styles.reduce}>
      <SectionTitle
        pattern="B"
        title={<>求人票を受け取った後の<br className={Styles.brsp} />事務作業を、もっと少なく。</>}
        lead="機能の話ではなく、「何をしなくてよくなるか」で見てください。"
      />

      <ul className={Styles.list}>
        {ITEMS.map((it) => (
          <li key={it}>
            <IoCheckmarkCircle className={Styles.icon} />
            <span className={Styles.strike}>{it}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Reduce;
